import { InjectionToken } from '@angular/core';
import { CountriesData, Countries } from 'countries-data';

export const COUNTRIES_DATA = new InjectionToken<Countries>('CountriesData');

export const TOKENS_PROVIDERS = [
  { provide: COUNTRIES_DATA, useValue: CountriesData }
];



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/tokens/countries.ts